import React, { useContext } from "react";
import { useRouter } from "next/router";
import { useSelector } from "react-redux";
import { RegionalBanner } from "@lululemon/mwa-seo";
import { NavContext } from "@lululemon/meganav";
import { publicConfig } from "@lululemon/ecom-core";
import { getGiftCard, getPages } from "../../store/selectors/mega-nav";
import {
  getCdpReduxLocales,
  getGiftCardReduxLocales,
  getPdpReduxLocales,
  getHyperLink,
  asPathWithoutParams,
} from "./regional-banner-wrapper-utils";

const RegionalBannerWrapper = () => {
  const router = useRouter();
  const pages = useSelector((state) => getPages(state.rootReducer));
  const giftCardRedux = useSelector((state) => getGiftCard(state.rootReducer));
  const { nav } = useContext(NavContext);

  const allLocaleValues =
    getPdpReduxLocales(pages, asPathWithoutParams(router)) ||
    getCdpReduxLocales(pages, asPathWithoutParams(router)) ||
    getGiftCardReduxLocales(giftCardRedux, router.asPath);

  const hyperLink = getHyperLink(nav, allLocaleValues, router);

  return (
    hyperLink && (
      <RegionalBanner
        contentfulConfig={publicConfig.contentful}
        locale={router.locale || ""}
        currentPath={router.asPath || ""}
        redirectionUrl={hyperLink}
      />
    )
  );
};

export default RegionalBannerWrapper;
